export default __webpack_public_path__ + "static/media/sortIcon.2d5c382c.svg";